import useFormErrorHandling from "hooks/useFormErrorHandling";
import { Field } from "components/Shared";
import { LoadingButton } from '@mui/lab';
import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { Box, Card, CardContent, CardHeader } from "@mui/material";
import { FIELDS, IChangePasswordForm, IChangePasswordFormProps, changePasswordFormSchema } from "./Form.config";

// Static vars

const HEADER_TITLE = "Cambiar contraseña";
const UPDATE_PASSWORD_LABEL = "Actualizar";
const INPUT_PASSWORD_TYPE = "password";

/**
 * Component to render change password form
 * 
 * @param { ( string ) => void } onSubmit - Function to submit form values
 * @param { boolean } isLoading - Api call loading flag
 * @param { FetchBaseQueryError | SerializedError | undefined } apiError - Api error on updating password
 */

export const Form = (props: IChangePasswordFormProps) => {

  const { onSubmit, apiError, isLoading } = props;

  // Form configuration

  const methods = useForm({
    resolver: zodResolver(changePasswordFormSchema),
  });

  const { setError } = methods;

  const onSubmitHandler: SubmitHandler<IChangePasswordForm> = (values: IChangePasswordForm) => {
    onSubmit(values.newPassword, values.currentPassword);
  };

  // Error handler hook

  useFormErrorHandling(setError, apiError);

  return (
    <FormProvider {...methods}>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={methods.handleSubmit(onSubmitHandler)}
      >
        <Card>
          <CardHeader sx= {{ textAlign: "center" }} title={HEADER_TITLE} />
          <CardContent>
            <Field.TextField sx={{ mb: "2rem" }} name={FIELDS.CURRENT_PASSWORD.FIELD} label={FIELDS.CURRENT_PASSWORD.LABEL} type={INPUT_PASSWORD_TYPE} />
            <Field.TextField sx={{ mb: "2rem" }} name={FIELDS.NEW_PASSWORD.FIELD} label={FIELDS.NEW_PASSWORD.LABEL} type={INPUT_PASSWORD_TYPE} />
            <Field.TextField sx={{ mb: "2rem" }} name={FIELDS.CONFIRM_PASSWORD.FIELD} label={FIELDS.CONFIRM_PASSWORD.LABEL} type={INPUT_PASSWORD_TYPE} />
            <LoadingButton loading={isLoading} variant='contained' disableElevation type='submit'>
              {UPDATE_PASSWORD_LABEL}
            </LoadingButton>
          </CardContent>
        </Card>
      </Box>
    </FormProvider>
  );
};